{
  "title": "My children",
  "description": "Homework progress for the children linked to you.",
  "empty": "No children are linked to your account in this school yet.",
  "noSubmissions": "Nothing has been handed in yet.",
  "loadFailed": "Could not load your children's homework.",
  "columns": {
    "homework": "Homework",
    "due": "Due",
    "status": "Status",
    "score": "Score"
  },
  "due": "Due {{date}}",
  "noDue": "No due date",
  "score": "{{score}} / {{max}}",
  "notGraded": "—",
  "feedback": "Teacher feedback",
  "privacyNote": "You only ever see your own children's work.",
  "viewProgress": "View progress"
}
